import React, { useState, useEffect, useContext, useCallback } from "react";
import {
  Panel,
  PanelHeader,
  PanelBody,
  PanelFooter,
} from "../../components/panel/panel.jsx";
import { Link, useHistory } from "react-router-dom";
import { WhatsApp } from "@material-ui/icons";
// import { parsePhoneNumberFromString, getCountryCallingCode, isValidPhoneNumber } from "libphonenumber-js";

import PhoneInput from "react-phone-number-input/input";
import {
  isValidPhoneNumber,
  isPossiblePhoneNumber,
} from "react-phone-number-input";
import "react-phone-number-input/style.css";
const UserWhatsApp = ({
  UserWhatsappNo,
  onChangewhatsappnumber,
  Updatewhatsappnumber,
}) => {
  const [error, setError] = useState("");
  const [isValid, setIsValid] = useState(null);
  const [isPossible, setIsPossible] = useState(null);
  const [country, setCountry] = useState("");

  useEffect(() => {
    if (!UserWhatsappNo) {
      setError("");
      setIsValid(null);
      setIsPossible(null);
      return;
    }
    setIsValid(isValidPhoneNumber(UserWhatsappNo));
    setIsPossible(isPossiblePhoneNumber(UserWhatsappNo));
  }, [UserWhatsappNo]);
  return (
    <div>
      <Panel>
        <PanelHeader>
          <h4 className="mb-0 text-light">
            <WhatsApp
              style={{ width: "67px", height: "59px" }}
              htmlColor="green"
            ></WhatsApp>{" "}
            WhatsApp
          </h4>
        </PanelHeader>
        <PanelBody className="p-0 bgwhite">
          <div
            className="form-group row my-2 profile-box p-0 mx-0 align-items-center"
          >
            <label className="col-xl-3 col-form-label left-border">
              <h5 className="mb-0">WhatsApp Number </h5>
            </label>
            <PhoneInput
              intinternational
              placeholder="Enter phone number"
              value={UserWhatsappNo}
              onChange={(e) => {
                onChangewhatsappnumber(e);
              }}
              className="form-control input-design-1 width250"
              style={{ fontSize: "16px" }}
            />
            {isValid === true && isPossible === true && (
              <p style={{ color: "green", marginLeft: "8px", marginBottom: "0" }}>
                ✅ Valid phone number
              </p>
            )}
            {(isValid === false || isPossible == false) && (
              <p style={{ color: "red", marginLeft: "8px", marginBottom: "0" }}>
                ❌ Invalid phone number
              </p>
            )}
          </div>
          <div className="row">
            <div className="col-sm-2"> </div>
            <div
              className="col-sm-6"
              style={{ marginTop: "42px", marginBottom: "34px" }}
            >
              <button
                type="button"
                className="btn btn-primary"
                onClick={() => {
                  Updatewhatsappnumber();
                }}
              >
                {" "}
                Update Number
              </button>
            </div>
          </div>
        </PanelBody>
      </Panel>
    </div>
  );
};

export default UserWhatsApp;
